import { z } from 'zod';

export const MediaFormatAdminSchema = z.object({
  id: z.number(),
  code: z.string(),
  label: z.string(),
  sortOrder: z.number().nullable(),
  groupId: z.number().nullable(),
  groupName: z.string().nullable(),
  isActive: z.boolean(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type MediaFormatAdmin = z.infer<typeof MediaFormatAdminSchema>;

export const CreateMediaFormatSchema = z.object({
  code: z.string().min(1),
  label: z.string().min(1),
  groupId: z.number().int().positive().nullable().optional(),
  sortOrder: z.number().int().positive().default(1),
  isActive: z.boolean().default(true),
});
export type CreateMediaFormat = z.infer<typeof CreateMediaFormatSchema>;

export const UpdateMediaFormatSchema = z
  .object({
    code: z.string().min(1),
    label: z.string().min(1),
    groupId: z.number().int().positive().nullable(),
    sortOrder: z.number().int().positive(),
    isActive: z.boolean(),
  })
  .partial()
  .strict();
export type UpdateMediaFormat = z.infer<typeof UpdateMediaFormatSchema>;

export const MediaFormatAdminListResponseSchema = z.object({
  items: z.array(MediaFormatAdminSchema),
  total: z.number(),
  page: z.number(),
  pageSize: z.number(),
});
export type MediaFormatAdminListResponse = z.infer<typeof MediaFormatAdminListResponseSchema>;

export const GroupChangeEffectSchema = z.object({
  roleName: z.string(),
  effect: z.enum(['gain', 'lose']),
});
export type GroupChangeEffect = z.infer<typeof GroupChangeEffectSchema>;

export const GroupChangeEffectsResponseSchema = z.object({
  effects: z.array(GroupChangeEffectSchema),
});
export type GroupChangeEffectsResponse = z.infer<typeof GroupChangeEffectsResponseSchema>;
